<template>
  <div class="p-0">
    <iframe
      height="40"
      width="100%"
      scrolling="no"
      :src="`${getIframePath()}/c/etc/OneDrivePicker.php?linkColor=%23646464&hoverColor=white&fontSize=16px&iconSize=16${langAndDirString()}`"
    />
  </div>
</template>

<script>
import BaseComponent from '@/components/commentsNew/BaseComponent'
import UsesCookies from '@/mixins/UsesCookies'

export default {
  name: 'AttachmentOptionOneDrivePicker',
  extends: BaseComponent,
  mixins: [UsesCookies],
  data () {
    return {
      readyToUpload: false,
      boundMessageHandler: this.messageHandler.bind(this)
    }
  },
  methods: {
    messageHandler (event) {
      if (event.data.oneDrivePickerOpened) {
        this.oneDrivePickerOpened()
      } else if (this.readyToUpload && event.data.oneDriveFiles) {
        this.oneDriveFiles(event.data.oneDriveFiles)
      } else if (event.data.oneDrivePickerCancelled) {
        this.oneDrivePickerCancelled()
      }
    },
    oneDrivePickerOpened () {
      this.readyToUpload = true
    },
    pickedDocMapper (file) {
      return {
        AttachmentLink: file.webUrl,
        AttachmentName: file.name,
        AttachmentType: 'oneDrive',
        IconURL: '/common_images/icons/onedrive.png'
      }
    },
    oneDriveFiles (files) {
      this.$emit('save-external-links', { links: files.map(this.pickedDocMapper) })
    },
    oneDrivePickerCancelled () {
      this.readyToUpload = false
    },
    langAndDirString () {
      const lang = this.getLangFromCookies()
      return '&lang=' + lang +
        '&dir=' + (['ar', 'iw'].includes(lang) ? 'rtl' : 'ltr')
    },
    getIframePath () {
      switch (process.env.VUE_APP_WORKING_ENV) {
        case 'dev': return 'https://dev1.atlasfirst.com'
        case 'development': return 'https://dev1.atlasfirst.com'
        case 'qa': return 'https://qa1.atlasfirst.com'
        case 'staging': return 'https://staging.rubiconatlas.org'
        default:
          return 'https://attachments.rubiconatlas.org'
      }
    }
  },
  mounted () {
    window.addEventListener('message', this.boundMessageHandler)
  }
}
</script>

<style scoped>
iframe {
  border: 0;
}
</style>
